// extracted by mini-css-extract-plugin
export default {"container":"iW-z","title":"jW-z","link":"kW-z"};